import React, { useCallback, useContext, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { ThemeContext } from 'styled-components';

import { useHistory } from 'react-router-dom';
import { Filiais } from '../../models/Filiais';
import Button from '../../components/Button';
import ListRegistButton from '../../components/ListRegistButton';
import NewImportExel from '../../components/NewImportExel';
import NewInput from '../../components/NewInput';
import { NewSearch } from '../../components/NewSearch';
import PaginationComponent from '../../components/Pagination';
import Table from '../../components/Table';
import { TitlePage } from '../../components/TitlePage/styled';
import ModalConexao from '../../components/ModalConexao';
import { useAuth } from '../../hooks/auth';
import api from '../../services/api';

import {
  Container,
  ContainerCadastro,
  DivLineBottom,
  HeaderForm,
  LabelInputForm,
} from './styles';

interface GetCategorias {
  id: number;
  name: string;
  companyId: number;
  createdAt: string;
}

const headers = [
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Empresa', field: 'companyId', sortable: true },
  { name: 'Data de criação', field: 'createdAt', sortable: true },
  { name: 'Editar', field: 'editOption', sortable: true },
  { name: 'Remover', field: 'deleteOption', sortable: true },
];
const headersFilter = [{ name: 'Nome', field: 'name', sortable: true }];

const Apontamentos: React.FC = () => {
  const { empresaPrincipal } = useAuth();
  const { go } = useHistory();
  const { colors } = useContext(ThemeContext);
  const [filiais, setFiliais] = useState<Filiais[]>([]);

  const [Categorias, setCategorias] = useState<GetCategorias[]>([]);
  const [indexInitPg, setIndexInitPg] = useState(0);
  const [indexEndPg, setIndexEndPg] = useState(0);
  // const [filialCategoria, setFilialCategoria] = useState(0);
  const [nameCategoria, setNameCategoria] = useState('');
  const [idCategoria, setIdCategoria] = useState(0);
  const [CategoriasFiltered, setCategoriasFiltered] = useState<GetCategorias[]>(
    [],
  );
  const [cadastrar, setCadastrar] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (nameCategoria !== '') {
      if (idCategoria !== 0) {
        api
          .put('/Categorias/', {
            id: idCategoria,
            name: nameCategoria,
            companyId: empresaPrincipal[0].ID,
          })
          .then(() => {
            Swal.fire({
              icon: 'success',
              title: 'Categoria cadastrada com sucesso!',
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp',
              },
              showConfirmButton: false,
            });
            setTimeout(() => {
              setCadastrar(false);
              // eslint-disable-next-line no-restricted-globals
              history.go(0);
            }, 1000);
          })
          .catch(() => {
            console.log('Num foi não hein');
          });
      } else {
        api
          .post('/Categorias/', {
            name: nameCategoria,
            companyId: empresaPrincipal[0].ID,
          })
          .then(() => {
            Swal.fire({
              icon: 'success',
              title: 'Categoria cadastrada com sucesso!',
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp',
              },
              showConfirmButton: false,
            });
            setTimeout(() => {
              setCadastrar(false);
              // eslint-disable-next-line no-restricted-globals
              history.go(0);
            }, 1000);
          })
          .catch(() => {
            console.log('Num foi não hein');
          });
      }
    }
  }, [empresaPrincipal, idCategoria, nameCategoria]);

  const getItems = useCallback(async () => {
    const CategoriasGet = await api.get(
      `Categorias?companyId=${empresaPrincipal[0].ID}`,
    );
    const FiliaisGet = await api.get(`/empresas/${empresaPrincipal[0].ID}`);

    setCategorias(CategoriasGet.data);
    setCategoriasFiltered(CategoriasGet.data);
    // console.log(CategoriasGet.data);
    setFiliais(FiliaisGet.data);
  }, [empresaPrincipal]);

  useEffect(() => {
    getItems();
  }, [getItems]);

  const handleSubmitEdit = (idCategoriaEdit: number): void => {
    const categoriaCurrent = Categorias.find(
      ({ id }) => id === idCategoriaEdit,
    );

    setNameCategoria(categoriaCurrent?.name!);
    setIdCategoria(categoriaCurrent?.id!);
    setCadastrar(true);
  };

  const handleSubmitDelete = useCallback(
    (idCat: number): void => {
      Swal.fire({
        title: 'Tem certeza que deseja deletar?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonColor: colors.success,
        cancelButtonColor: colors.error,
        confirmButtonText: 'Sim',
      }).then((result) => {
        if (result.isConfirmed) {
          const obj = { id: idCat };
          api
            .delete('/categorias', { data: obj })
            .then(() => {
              Swal.fire({
                icon: 'success',
                title: 'Categoria deleteda com sucesso!',
                showClass: {
                  popup: 'animate__animated animate__fadeInDown',
                },
                hideClass: {
                  popup: 'animate__animated animate__fadeOutUp',
                },
                showConfirmButton: false,
              });
              setTimeout(() => {
                setCadastrar(false);
                go(0);
              }, 1000);
            })
            .catch((err) => {
              console.log('ERRR', err.message);
              Swal.fire({
                icon: 'error',
                title: 'Ocorreu um erro!',
                showClass: {
                  popup: 'animate__animated animate__fadeInDown',
                },
                hideClass: {
                  popup: 'animate__animated animate__fadeOutUp',
                },
                showConfirmButton: false,
              });
            });
        }
      });
      //
    },
    [colors.error, colors.success, go],
  );

  return (
    <>
      <ModalConexao />
      <Container>
        <TitlePage>Categorias</TitlePage>
        <ListRegistButton
          object={{ list: 'Listar', regist: 'Registrar' }}
          setStateCadastrar={setCadastrar}
          stateCadastrar={cadastrar}
        />
        {!cadastrar && (
          <>
            <NewSearch
              arraySetState={setCategoriasFiltered}
              arrayState={Categorias}
              selectFilters={headersFilter}
            />
            <Table
              header={headers}
              body={CategoriasFiltered.filter(
                (e, i) => i >= indexInitPg && i <= indexEndPg,
              )}
              tableId="TableCategorias"
              filiais={filiais}
              setEditId={(id) => {
                handleSubmitEdit(id);
              }}
              setRemoveId={(id) => handleSubmitDelete(id)}
            />
            <PaginationComponent
              arrayStateFiltered={CategoriasFiltered}
              setIndexPagination={(indexInit, indexEnd) => {
                setIndexInitPg(indexInit);
                setIndexEndPg(indexEnd);
              }}
            />
            <NewImportExel fileName="Categorias" tableId="TableCategorias" />
          </>
        )}
        {cadastrar && (
          <ContainerCadastro>
            <HeaderForm>Cadastro de Vistorias</HeaderForm>
            <DivLineBottom />

            <LabelInputForm>Nome</LabelInputForm>
            <NewInput
              name="Categorias"
              placeholder="Digite aqui..."
              setStateValue={setNameCategoria}
              stateValue={nameCategoria}
            />
            <div className="buttonContainer">
              <Button id="cancel">Cancelar</Button>
              <Button onClick={handleSubmit}>Salvar</Button>
            </div>
          </ContainerCadastro>
        )}
      </Container>
    </>
  );
};

export default Apontamentos;
